import React from 'react';

export function SettingHeader({ title, description, className }) {
  return (
    <div className={`${className} phone-setting-header`}>
      <h5 className="standard-margin-left standard-margin-top settings-header-title">{title}</h5>
      <h6 className="standard-margin-left standard-small-margin-top settings-sub-title">{description}</h6>
      <div className="divider standard-margin standard-margin-bottom"></div>
    </div>
  );
}